// src/components/ui/Spinner.tsx
// Uses .spinner CSS class from GlobalStyles — no inline styles.

interface Props {
  size?: 'sm' | 'md' | 'lg';
}

export function Spinner({ size = 'md' }: Props) {
  return (
    <div className={`spinner${size !== 'md' ? ` spinner--${size}` : ''}`} />
  );
}